module.exports = __webpack_public_path__ + "static/media/logo.b5be4e95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 735
// module chunks = 0